
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    HostBinding,
    inject,
    input,
    signal
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Store } from '@ngxs/store';
import { EntityFormModeType } from '@shared/types/entity-form-mode.type';
import {
    UserAPIInfoGraphQLSchemaActions,
    UserAPIInfoGraphQLSchemaSelectors,
    UserAPIInfoType,
    UserAPIInfoTypeFormGroup,
    UserAPIInfoTypeFormGroupSelector,
    UserAPIInfoTypeQuery
} from '@shared/zigra-schemas/zigra-schema.autogenerated.models';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ObjectId, QueryFilterGroup } from 'zigra-ng-framework';
import { FloatLabel } from 'primeng/floatlabel';
import { ZFloatLabelComponent } from '@shared/components/form-components/z-float-label/z-float-label.component';
import { Button, ButtonModule } from 'primeng/button';
import { ZFloatLabelNumberComponent } from '@shared/components/form-components/z-float-label-number/z-float-label-number.component';
import { LoaderService } from '@shared/services/loader.service';
import { finalize } from 'rxjs';
import { ZionMessagesService } from '@shared/services/ax-messages.service';
import { ToastMessageOptions } from 'primeng/api';

@Component({
    selector: 'z-aade-rest-api-edit',
    imports: [
    FormsModule,
    ReactiveFormsModule,
    ZFloatLabelComponent,
    ButtonModule
],
    templateUrl: './z-aade-rest-api-edit.component.html',
    styleUrl: './z-aade-rest-api-edit.component.scss'
    // changeDetection: ChangeDetectionStrategy.OnPush
})
export class ZAadeRestApiEditComponent {
    @HostBinding('style') style = 'height: 100%';
    productDialogMode = input<EntityFormModeType | undefined>(undefined);
    userAPIInfoId = input<ObjectId | undefined>(undefined);
    userAPIInfo = signal<UserAPIInfoType | undefined>(undefined);
    userAPIInfos = signal<UserAPIInfoType[] | undefined>(undefined);
    selectedUserAPIInfoId?: ObjectId;

    protected store = inject(Store);
    protected cd = inject(ChangeDetectorRef);
    protected loaderService = inject(LoaderService);
    protected messageService = inject(ZionMessagesService);
    protected formGroup?: UserAPIInfoTypeFormGroup;
    protected dialogConfig: DynamicDialogConfig<IUserAPIInfoEditOptions> =
        inject(DynamicDialogConfig<IUserAPIInfoEditOptions>);

    ngOnInit(): void {
        // this.productDepartment()?.Code;
        // this.productDepartment()?.Title;
        // this.productDepartment()?.Description;
        // this.productDepartment()?.ParentId;
        //this.productDepartment()?.VATCategoryId;

        //this.productPackage()?.InvoicingList?.[0]?.VATCategoryId

        const groupQuery = {
            GroupQuery: QueryFilterGroup.JoinWithOrOperator([
                QueryFilterGroup.FieldIsEqualToObjectId<UserAPIInfoType>(
                    ['_id'],
                    this.userAPIInfoId() ?? '000000000000000000000000'
                )
            ])
        };

        // if (this.posTerminalId() == undefined)
        //     this.posTerminal.set({
        //         Code: undefined,
        //         Title: undefined,
        //         Description: undefined
        //     } as POSTerminalType);
        // else
        this.store
            .dispatch(
                new UserAPIInfoGraphQLSchemaActions.Fetch(
                    queryForEdit,
                    undefined //groupQuery
                )
            )
            .subscribe(() => {
                const userAPIInfos = this.store.selectSnapshot(
                    UserAPIInfoGraphQLSchemaSelectors.FetchSelector('', '')
                )?.data?.Fetch;

                this.userAPIInfos.set(userAPIInfos);

                // const posTerminals =
                //     this.store.selectSnapshot(
                //         POSTerminalGraphQLSchemaSelectors.FetchSelector('', '')
                //     )?.data?.Fetch ?? [];

                this.userAPIInfo.set(this.userAPIInfos()?.[0]);
                this.selectedUserAPIInfoId = this.userAPIInfo()?._id;
                debugger;

                this.formGroup = new UserAPIInfoTypeFormGroup(
                    this.userAPIInfo(),
                    formForEditSelector
                );

                // debugger;
                // this.formGroup.clearValidators();
                // this.formGroup.controls.Parent?.patchValue(undefined as any);

                // this.formGroup.controls.Code?.addValidators([Validators.required]);
                // this.formGroup.controls.Code?.updateValueAndValidity();
                // this.formGroup.controls.Title?.addValidators([Validators.required]);
                // this.formGroup.controls.Title?.updateValueAndValidity();
                // this.formGroup.controls.Description?.addValidators(Validators.required);
                // this.formGroup.controls.Description?.updateValueAndValidity();
                // this.formGroup.controls.VATCategoryId?.addValidators(
                //     Validators.required
                // );
                // this.formGroup.controls.VATCategoryId?.updateValueAndValidity();

                // this.formGroup?.updateValueAndValidity();
                // this.formGroup?.markAllAsTouched();

                if (this.dialogConfig.data)
                    this.dialogConfig.data.userAPIInfoTypeFormGroup =
                        this.formGroup;

                this.cd.detectChanges();
            });
    }

    // onSelectPOSTerminal(posTerminalId: ObjectId) {
    //     this.userAPIInfo.set(
    //         this.userAPIInfos()?.find(
    //             (posTerminal) => posTerminal._id == posTerminalId
    //         )
    //     );
    // }

    saveUserApiInfo() {
        const userAPIInfo = this.formGroup?.value as UserAPIInfoType;
        userAPIInfo.MyDataKey =
            userAPIInfo.MyDataKey?.trim() == ''
                ? undefined
                : userAPIInfo.MyDataKey?.trim();
        userAPIInfo.MyDataUser =
            userAPIInfo.MyDataUser?.trim() == ''
                ? undefined
                : userAPIInfo.MyDataUser?.trim();

        this.loaderService.showAwaitDataSaveLoader();
        this.store
            .dispatch(
                new UserAPIInfoGraphQLSchemaActions.Upsert(
                    userAPIInfo,
                    undefined,
                    UserAPIInfoTypeQuery.GQLQuery()
                )
            )
            .pipe(finalize(() => this.loaderService.dismissAwaitLoader()))
            .subscribe(() => {
                this.messageService.add({
                    summary: 'Καταχώρηση Κωδικών MyData',
                    detail: 'Η Καταχώρηση ολοκληρώθηκε επιτυχώς',
                    severity: 'success',
                    key: 'br'
                } as ToastMessageOptions);

                this.dialogConfig.data?.onSave?.(this.dialogConfig.data);
            });
    }
}

const queryForEdit = UserAPIInfoTypeQuery.GQLQueryWith();

const formForEditSelector = new UserAPIInfoTypeFormGroupSelector();

export interface IUserAPIInfoEditOptions {
    mode: 'new' | 'edit' | 'view' | 'delete';
    //dclId?: number;
    //digitalClientCardType: DigitalClientCardType;
    userAPIInfoTypeFormGroup?: UserAPIInfoTypeFormGroup;

    onSave: (options: IUserAPIInfoEditOptions) => void;
}
